export default {
  created() {
    if (this.disableScrolling) {
      document.body.classList.add('overflowHidden')
    }
  },
  unmounted() {
    if (this.disableScrolling) {
      document.body.classList.remove('overflowHidden')
    }
  },
  destroyed() {
    if (this.disableScrolling) {
      document.body.classList.remove('overflowHidden')
    }
  },
}
